import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { ApiService } from '../api.service';

@Injectable()
export class CpProfilesService {

  constructor(
    private apiService: ApiService
  ) { }

  // Get methods
  getProfiles(): Observable<any[]> {
    return this.apiService.client.cp.profiles.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getProfileId(profileId: string): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getProfileRules(profileId: string): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).rules.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  getProfileRulesId(profileId: string, ruleId: string): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).rules.ruleId(ruleId).GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  // Post methods
  postProfile(body: any): Observable<any[]> {
    return this.apiService.client.cp.profiles.POST(body)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  postRules(profileId: string, body: any): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).rules.POST(body)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  // Patch methods
  patchProfile(profileId: string, body: any): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).PATCH(body)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  patchRules(profileId: string, ruleId: string, body: any): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).rules.ruleId(ruleId).PATCH(body)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  // delete methods
  deleteProfile(profileId: string): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).DELETE()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  deleteRule(profileId: string, ruleId: string): Observable<any[]> {
    return this.apiService.client.cp.profiles.profileId(profileId).rules.ruleId(ruleId).DELETE()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/api/cp-profiles.service.ts